import { Map as ImmutableMap } from 'immutable';
import { DateTime } from 'luxon';

import { REDUCER_KEY } from './reducer';
import { mkShare } from './types';

export const getSharestore = (state) => state[REDUCER_KEY];

// required default selectors
export const getResourcesById = (state) => getSharestore(state).resourcesById;
export const getLoadPending = (state) => getSharestore(state).loadPending;
export const getIsLoading = (state) => getSharestore(state).isLoading;
export const getError = (state) => getSharestore(state).error;
export const getLastSyncDate = (state) => getSharestore(state).lastSyncDate;

export const getSharesById = (state) => getSharestore(state).resourcesById;

export const getSharesByIdForTesting = () =>
  ImmutableMap([
    [
      '1',
      mkShare({
        id: '1',
        granteeFirstName: 'Kelly',
        granteeLastName: 'Tong',
        granteeEmail: 'kellyjoyner3@gmail.com',
        status: 'ACTIVE',
        createdAt: DateTime.fromISO('2022-01-01T12:00:00.000'),
      }),
    ],
    [
      '2',
      mkShare({
        id: '2',
        granteeFirstName: 'Kristen',
        granteeLastName: 'Dillard',
        granteeEmail: 'kristen_dillard@quicken.com',
        status: 'INVITED',
        createdAt: DateTime.fromISO('2022-01-05T12:00:00.000'),
      }),
    ],
  ]);
